import { AssistantAvatar, KW, TypingDots } from './ui'

/** Assistant-side row shown while a tool runs: avatar + blinking dots + the server's activity label. */
const ToolActivityIndicator = ({ label }: { label?: string | null }) => {
  return (
    <div className="kw-up flex items-center gap-[10px]">
      <AssistantAvatar size={28} />
      <TypingDots />
      {label && (
        <span className="text-xs" style={{ color: KW.muted }}>
          {label}
        </span>
      )}
    </div>
  )
}

export default ToolActivityIndicator
